import React, { useEffect, useState } from "react";
import { useAppServices } from "../../../hook/services";
import { useSocket } from "../../../context/socket";
import { useSSOInfo } from "../../../context/sso";
import CreateTicket from "./components/Modals/CreateTicket";
import { useParams } from "react-router-dom";
import TicketSidebar from "./components/TicketSidebar";
import TicketChat from "./components/TicketChat";
import LoadingScreen from "../../../components/LoadingScreen";
import env from "../../../config";

const TicketLayer = () => {
  const [SSOData] = useSSOInfo();
  const socket = useSocket();
  const AppService = useAppServices();
  const { companyId, locationId } = useParams();

  const [processing, setProcessing] = useState(true);
  const [apps, setApps] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [messages, setMessages] = useState([]);
  const [activeTicket, setActiveTicket] = useState(null);
  // ✅ Fetch Apps
  const getApps = async () => {
    try {
      const { response } = await AppService.apps.get();
      setApps(response ? response.data : []);
    } catch (err) {}
  };

  // ✅ Fetch Tickets
  const getTickets = async () => {
    try {
      const { response } = await AppService.support.get_tickets_with_messages({
        query: `locationId=${locationId}&appId=${env.GHL.APP_ID}`,
      });
      if (response) {
        setTickets(response.data);
        setMessages(response.messages);
      } else {
        setTickets([]);
        setMessages([]);
      }
    } catch (err) {
      console.error("Error fetching tickets:", err);
    }
  };

  // ✅ Initial load
  useEffect(() => {
    const load = async () => {
      await Promise.all([getApps(), getTickets()]);
      setProcessing(false);
    };
    load();
  }, []);

  // ✅ Socket listeners
  useEffect(() => {
    if (!socket) return;

    const handleMessageResponse = (data) => {
      setMessages((prev) => [...prev, data]);
    };

    const handleTicketStatus = ({ _id, status }) => {
      setTickets((prev) =>
        prev.map((t) => (t._id === _id ? { ...t, status } : t))
      );
      if (activeTicket?._id === _id) {
        setActiveTicket((prev) => ({ ...prev, status }));
      }
    };

    socket.on("messageResponse", handleMessageResponse);
    socket.on("ticketStatusUpdated", handleTicketStatus);

    return () => {
      socket.off("messageResponse", handleMessageResponse);
      socket.off("ticketStatusUpdated", handleTicketStatus);
    };
  }, [socket, activeTicket]);

  // ✅ Loading screen
  if (processing) {
    return <LoadingScreen loadingText={"Loading tickets..."} />;
  }

  return (
    <div className="chat-wrapper">
      {/* Sidebar */}
      <div className="chat-sidebar card">
        <div className="chat-sidebar-single" style={{ cursor: "unset" }}>
          <CreateTicket apps={apps} handleRefresh={getTickets} />
        </div>
        <TicketSidebar
          tickets={tickets}
          activeTicket={activeTicket}
          setActiveTicket={setActiveTicket}
        />
      </div>

      {/* Ticket Conversation */}
      <div className="chat-main card">
        <TicketChat
          SSOData={SSOData}
          socket={socket}
          activeTicket={activeTicket}
          messages={messages}
          setMessages={setMessages}
        />
      </div>
    </div>
  );
};

export default TicketLayer;
